import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as actions from '../../actions'
import StoneTable from '../common/stone_table'
import ConfirmStonesModal from '../common/confirm_stones_modal'

class CartInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStones: {},
            requestRemarks: null
        };
    }

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        this.props.getCart()
        this.props.getDesires('carted')
        .then(desires => desires.forEach(d => this.props.priceDesire(d)))
    }

    handleRowSelect = (selected) => {
        this.setState({selectedStones: selected});
    }

    getSelectedStones = () => {
        if (!this.state.selectedStones) return [];
        return Object.keys(this.state.selectedStones).filter(parcelName => this.state.selectedStones[parcelName]);
    }

    removeSelectedStone = parcelName => {
        this.setState({selectedStones: {...this.state.selectedStones, [parcelName]: false}})
    }

    removeFromCart = (stone) => {
        if (stone.virtual) {
            stone.desire.status = 'CANCELLED';
            this.props.updateDesire(stone.desire)
            .then(() => this.props.getDesires('carted'))
        } else {
            this.props.removeFromCart(stone.parcelName)
            .then(() => this.props.getCart())
        }
    }

    requestStones = () => {
        const {stones, desires} = this.getSelectedStones().reduce(({stones,desires},parcelName) => {
            if (parcelName.startsWith('desire-')) return {stones, desires: [...desires, Number(parcelName.substring(7))]};
            else return {stones: [...stones, parcelName], desires}
        }, {stones: [], desires: []});
        if (!stones.length && !desires.length) return;
        return this.props.requestStones(stones, this.state.requestRemarks, desires)
        .then(() => this.setState({requestRemarks: null, selectedStones: {}}))
        .then(this.refresh)
    }

    renderInventory = () => {
        const inventory = this.props.inventory || [];
        const desires = this.props.desires || [];
        const selected = this.getSelectedStones();
        return (
            <div>
                <div className='row spaced'>
                    <ConfirmStonesModal
                        confirm={this.requestStones} 
                        title='Confirm Request'
                        message={`Review ${selected.length} stones and click "Request Stones" to confirm.`} 
                        confirmCaption='Request Stones'
                        deleteStone={this.removeSelectedStone}
                        trigger={onClick => <button className='btn' onClick={onClick} disabled={selected.length==0}>Request</button>}
                        stones={
                            inventory.filter(stone => selected.includes(stone.parcelName))
                            .concat(desires.filter(d => selected.includes(d.parcelName)))
                        }
                        comment={this.state.requestRemarks}
                        updateComment={(e) => this.setState({requestRemarks: e.target.value})}
                    />
                </div>
                <StoneTable 
                    data={inventory.concat(desires)}
                    extraColumns={[
                        {
                            Header: '',
                            id: 'removeBtn',
                            width: 50,
                            sortable: false,
                            filterable: false,
                            Cell: (row) => row.original ? (
                                <button
                                    title="Remove from Cart"
                                    className="list-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.removeFromCart(row.original);
                                    }}
                                >{
                                    <i className='fa fa-times-circle' />
                                }</button>
                            ) : null
                        }
                    ]}
                    selectedRows={this.state.selectedStones}
                    onSelectRows={this.handleRowSelect}
                    exporter={this.props.excelExport}
                    tableId='cart'
                    large={true}
                />
            </div>
        )
    }

    render() {
        return (
            <div style={{width: '100%'}}>
                {this.renderInventory()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        inventory: state.inventory.cart,
        desires: state.inventory.cart_desires
    }
}

export default connect(mapStateToProps, actions)(CartInventory)